import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef
} from '@angular/material/dialog';
import { IKidsHotel } from '@mng/mgs-lib';
import { MatButton } from '@angular/material/button';
import { MGS_HOTEL_ICON } from '../../mgs-svg-icon.helper';
import { MngOutComponent } from '@mng/mng-base-ui';
import { MngDialogHeaderComponent } from '@mng/mng-inputs';

export interface IKidsHotelInfoParams {
  hotel: IKidsHotel;
}

@Component({
  imports: [MatDialogContent, MatDialogActions, MatButton, MatDialogClose, MngOutComponent, MngDialogHeaderComponent],
  templateUrl: './kids-hotel-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KidsHotelInfoComponent {
  dialogRef = inject<MatDialogRef<KidsHotelInfoComponent>>(MatDialogRef);
  data = inject<IKidsHotelInfoParams>(MAT_DIALOG_DATA);

  MGS_HOTEL_ICON = MGS_HOTEL_ICON;

  close() {
    this.dialogRef.close();
  }
}
